import React from "react";

import { ReactComponent as EmailSVG } from "../images/mail_sent.svg";

export default function Success(props) {
  const response = props.response;
  const product = props.product;

  return (
    <div>
      <div className="flex justify-between">
        <h4 className="text-2xl font-semibold">Success</h4>
      </div>
      <p className="leading-relaxed mt-1 mb-4 text-gray-600">
        Payment of ${product.totalPrice} was successful. You have been emailed a
        link to download the form.
      </p>
      <EmailSVG className="h-40 mx-auto my-12 container" />
      <br />
      <p className="mb-2">Alternatively, you can download your forms here:</p>
      <div className="flex flex-col justify-between mt-2 flex-wrap">
        <a
          href={response.download}
          className="text-white bg-[#3059a9] hover:bg-[#31b7e6] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 "
        >
          Download Residential Tenancy Agreement
        </a>
      </div>
      <div className="flex flex-col justify-between mt-2 flex-wrap">
        <a
          target="_blank"
          rel="noreferrer"
          href={response.report}
          className="text-white bg-[#3059a9] hover:bg-[#31b7e6] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 "
        >
          Download Condition Report
        </a>
      </div>
      <div className="flex flex-col justify-between mt-2 flex-wrap">
        <a
          target="_blank"
          rel="noreferrer"
          href={response.rentalGuide}
          className="text-white bg-[#3059a9] hover:bg-[#31b7e6] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 "
        >
          Find your rental guide here
        </a>
      </div>
      <div className="flex flex-col justify-between mt-2 flex-wrap">
        <a
          target="_blank"
          rel="noreferrer"
          href={response.bondGuide}
          className="text-white bg-[#3059a9] hover:bg-[#31b7e6] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 "
        >
          How to lodge or pay a bond
        </a>
      </div>
      <div className="mt-2">
        <span>Need another form? </span>
        <a
          target="_blank"
          href="/"
          className="no-underline font-semibold hover:underline hover:text-[#31b7e6] text-[#3059a9]"
          rel="noreferrer"
        >
          Click Here
        </a>
      </div>

    </div>
  );
}
